class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState?.key;

    const sections = parsedState?.sections || {};
    const sectionsToRender = this.getSectionsToRender();

    // Update the visible cart counter first. A missing product preview must
    // never prevent the header from reflecting the current cart state.
    const cartIconSection = sectionsToRender.find((section) => section.id === 'cart-icon-bubble');
    const cartIconUpdated = this.renderSection(cartIconSection, sections['cart-icon-bubble']);

    sectionsToRender
      .filter((section) => section.id !== 'cart-icon-bubble')
      .forEach((section) => this.renderSection(section, sections[section.id]));

    // The Section Rendering API is a safe fallback when an app returns an
    // incomplete add-to-cart response or changes the line-item key.
    if (!cartIconUpdated) this.refreshCartIconBubble();

    if (this.header) this.header.reveal();
    this.open();
  }

  renderSection(section, html) {
    if (!section || typeof html !== 'string') return false;

    const innerHTML = this.getSectionInnerHTML(html, section.selector);
    if (innerHTML === null) return false;

    const sectionElements =
      section.id === 'cart-icon-bubble'
        ? document.querySelectorAll('#cart-icon-bubble')
        : [document.getElementById(section.id)];

    let rendered = false;

    sectionElements.forEach((sectionElement) => {
      if (!sectionElement) return;
      sectionElement.innerHTML = innerHTML;
      rendered = true;
    });

    return rendered;
  }

  async refreshCartIconBubble() {
    try {
      const sectionUrl = new URL(window.location.href);
      sectionUrl.searchParams.set('sections', 'cart-icon-bubble');

      const response = await fetch(sectionUrl.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!response.ok) return;

      const renderedSections = await response.json();
      this.renderSection(
        { id: 'cart-icon-bubble' },
        renderedSections?.['cart-icon-bubble']
      );
    } catch (error) {
      // The cart itself was already updated. Keep the add-to-cart flow usable
      // even if the optional visual refresh cannot be loaded.
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (typeof html !== 'string') return null;

    const sectionElement = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return sectionElement ? sectionElement.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
